export var pillImageStyles = {
  root: function root(_ref) {
    var p = _ref.props,
        v = _ref.variables;
    return Object.assign({
      width: v.imageWidth,
      height: v.imageHeight,
      borderRadius: '50%'
    }, p.size === 'small' && {
      width: v.smallImageWidth,
      height: v.smallImageHeight
    }, p.size === 'smaller' && {
      width: v.smallerImageWidth,
      height: v.smallerImageHeight
    });
  }
};